import React, { useState } from "react";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";

const diplomaStatusList = [
  { key: "not_checked", value: "Baxılmayıb" },
  { key: "in_design", value: "Dizayndadır" },
  { key: "in_print", value: "Çapdadır" },
  { key: "in_office", value: "Ofisdədir" },
  { key: "debt_in_office", value: "Borcludur, ofisdədir." },
  { key: "delivered", value: "Tələbəyə təhvil verilib" },
];

const StudentDiplomaStatusDropdown = ({ currentStatus, onChangeStatus }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
     const [localStatus, setLocalStatus] = useState(currentStatus);



  const currentLabel =
    diplomaStatusList.find((s) => s.key === localStatus)?.value ||
    "Seçin";

  const handleSelect = (statusKey) => {
    setLocalStatus(statusKey)
    onChangeStatus(statusKey); // bubble the chosen key up to parent
    setDropdownOpen(false);
  };

  return (
    <div 
    style={{width:"180px"}}
      className={`global-category-dropdown dropdown-name data-status ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <span>{currentLabel}</span>
        <div className="arrow-icon" style={{ marginLeft: "10px" }}>
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {diplomaStatusList.map((status) => (
            <li  style={{paddingLeft:12,textAlign:"center"}} key={status.key} onClick={() => handleSelect(status.key)}>
              {status.value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default StudentDiplomaStatusDropdown;